export { default } from './GenerateSkeleton'
